import { useEffect, useState } from 'react';
import AuthService from '../../services/authService';

const useClearCookies = (redirectUri: string) => {
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const authService = new AuthService();

    if (authService.isAuthenticated()) {
      authService
        .logoutAndRedirect(redirectUri)
        .then(() => {
          setIsSuccess(true);
        })
        .catch(() => {
          setIsSuccess(false);
        });
    } else {
      setIsSuccess(true);
    }
  }, [redirectUri]);

  return isSuccess;
};

export default useClearCookies;
